"use client";

import { c as _c } from "react/compiler-runtime";
import { setWalletTrackingParameters } from "@opensea/analytics";
import { useRouter } from "@opensea/navigation";
import { useOnChange } from "@opensea/ui-kit/hooks";
import { BigNumber } from "@opensea/utils";
import { useAccount, useBalances } from "@opensea/wallet";
import { useEffect } from "react";
import { useConnectedAccountServerHint } from "@/hooks/use-connected-account-server-hint";
import { identify } from "@/lib/integrations/identify";

/**
 * Identify a user when we know who they are.
 */
export const useWalletTracking = () => {
  const $ = _c(13);
  const {
    address,
    connectorId,
    chainId,
    authenticated
  } = useAccount();
  const [, setServerHint] = useConnectedAccountServerHint();
  const router = useRouter();
  const {
    balances,
    loading: loadingBalances
  } = useBalances();
  let t0;
  let t1;
  if ($[0] !== address || $[1] !== setServerHint) {
    t0 = () => {
      identify(address);
      setServerHint(address ?? "");
    };
    t1 = [address, setServerHint];
    $[0] = address;
    $[1] = setServerHint;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] !== router) {
    t2 = () => {
      router.refresh();
    };
    $[4] = router;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useOnChange(address, t2);
  let t3;
  let t4;
  if ($[6] !== authenticated || $[7] !== balances || $[8] !== chainId || $[9] !== connectorId || $[10] !== loadingBalances) {
    t3 = () => {
      setWalletTrackingParameters({
        chainId,
        web3Wallet: connectorId,
        totalUsdBalance: loadingBalances ? undefined : BigNumber.sum(...balances.map(_temp)).toNumber(),
        balanceByChain: loadingBalances ? undefined : balances.reduce(_temp2, {}),
        authenticated
      });
    };
    t4 = [chainId, connectorId, balances, loadingBalances, authenticated];
    $[6] = authenticated;
    $[7] = balances;
    $[8] = chainId;
    $[9] = connectorId;
    $[10] = loadingBalances;
    $[11] = t3;
    $[12] = t4;
  } else {
    t3 = $[11];
    t4 = $[12];
  }
  useEffect(t3, t4);
};
function _temp(b) {
  return b.usdValue;
}
function _temp2(acc, b_0) {
  const currentTotal = acc[b_0.currency.chainIdentifier] ?? 0;
  acc[b_0.currency.chainIdentifier] = currentTotal + Number(b_0.usdValue);
  return acc;
}